import React from "react";
import styled from "@emotion/styled";
import {
  BrandCheckList,
  CategoryInput,
  ProductNameInput,
} from "@pages/register/_components/index";
import BasicButton from "@components/button/BasicButton";
import { useFormContext } from "react-hook-form";
import useRegisterStepStore from "@store/register/useRegisterStepStore";
import { useTranslation } from "react-i18next";
import FadeInContainer from "@components/motion/FadeInContainer";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
});

const Title = styled.h3(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  fontSize: "2rem",
  lineHeight: "2.8rem",
  fontWeight: theme.fontWeight.bold,
}));

const RegisterProductStepOne = () => {
  const { t } = useTranslation();
  const { increaseStep } = useRegisterStepStore();
  const { watch, trigger } = useFormContext();

  const name_ko = watch("name_ko");
  const brand_id = watch("brand_id");
  // const depth1 = watch("depth1");

  const valid = async () => {
    // 현재 스텝의 필드들만 검증
    const isStepValid = await trigger(["name_ko", "depth1", "brand_id"]);

    if (isStepValid) {
      increaseStep();
    }
  };

  return (
    <Container>
      <Title>
        <span>{t("등록하려는 상품의")}</span>
        <span>{t("상세정보를 알려주세요.")}</span>
      </Title>

      <FadeInContainer isShow={brand_id !== 0 && !!name_ko}>
        <CategoryInput />
      </FadeInContainer>

      <ProductNameInput />

      <BrandCheckList />

      <FadeInContainer isShow={brand_id !== 0 && !!name_ko}>
        <BasicButton
          title="다음"
          height="5.2rem"
          width="100%"
          padding="1.6rem 1.2rem"
          onClick={valid}
          // disabled={!name_ko || !depth1 || !brand_id}
        />
      </FadeInContainer>
    </Container>
  );
};

export default RegisterProductStepOne;
